import { getTierClassification } from '../../utils/tierClassification';

function getCookie(name) {
	let cookie = {}
	document.cookie.split(';').forEach(function (el) {
		let [k, v] = el.split('=')
		cookie[k.trim()] = v
	})
	return cookie[name]
}


export function getRDTRKCookie() {
	const cookie = getCookie('rdtrk')
	const decodedCookie = decodeURIComponent(cookie)
	let cookieObject
		try {
			cookieObject = JSON.parse(decodedCookie)
		} catch(e){
			console.log("invalid cookie")
		cookieObject = ""
		}

	return cookieObject
}

function getBirthYear(age){
	let ageNumber = Number(age)
	const todaysYear = new Date().getFullYear()
	return todaysYear - ageNumber
}

export const buildPayload = (data, form, destination = "RD") =>{
	const RDID = getRDTRKCookie().id

	// Calculate tier classification based on savedMoney (patrimonio atual)
	const tier = getTierClassification(data.savedMoney);

	const shared = {
		'conversion_identifier': 'simulator_conversion',
		'name': form.name ,
		'email': form.email,
		'personal_phone': form.phone,
		'idade': data.age,
		'cf_ano_de_nascimento': data.age? getBirthYear(data.age).toString() : "Vazio",
		'cf_capacidade_de_poupanca': data.monthlySave? data.monthlySave.toString() : "Vazio",
		'cf_idade_de_independencia_financeira': data.independenceAge? data.independenceAge.toString(): "Vazio",
		'cf_montante_da_renda_extra': data.INSSmonthlyRetirement? data.INSSmonthlyRetirement.toString(): "Vazio",
		'cf_idade_que_recebera_outra_fonte_de_renda': data.INSSage? data.INSSage.toString(): "Vazio",
		'cf_perfil_de_investimento': data.investment? data.investment : "Vazio",
		'cf_poupanca_atual': data.savedMoney? data.savedMoney.toString() : "Vazio",
		'cf_renda_desejada_na_aposentadoria': data.desiredRetirement? data.desiredRetirement.toString() : "Vazio",
		'cf_mensal_renda': data.monthlyIncome? data.monthlyIncome.toString() : "Vazio",
		'cf_tem_outra_fonte_de_renda': data.retirement ? data.retirement : "Vazio",
		'cf_tier': tier,
		'client_tracking_id': RDID,
		'traffic_source': getCookie('__trf.src'),
	}

	if(destination === "RD"){
		return shared
	}

	return {
		people: {
			"$email": form.email,
			"USER_ID": RDID
		},
		track: {
			...shared,
			"$email": form.email
		}
	}
}


const buildBody = (payload) => {
	return {
		'event_type': 'CONVERSION',
		'event_family': 'CDP',
		payload
	}
}
const headers = new Headers()
headers.append('Content-Type', 'application/json')

export const integrate = (data, form) => {
	const RDpayload = buildPayload(data,form, "RD")
	const body = buildBody(RDpayload)

	return fetch('https://api.rd.services/platform/conversions?api_key=8d81950c6b78452601cc7f796f45411a', {
		method: 'POST',
		headers,
		body: JSON.stringify(body)
	})
}
